import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

import {
  DEFAULT_LOCALE,
  FALLBACK_LOCALE,
  LOCALES,
  LOCALE_STORAGE_KEY,
  NAMESPACES,
  type Locale,
} from "./config"

void i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [...LOCALES],
    fallbackLng: FALLBACK_LOCALE,
    defaultNS: "common",
    ns: [...NAMESPACES],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "htmlTag", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
    },
    backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
    returnNull: false,
  })
  .catch((e) => console.error("i18n init failed", e))

// Keep <html lang="…"> in sync with the active locale.
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng
})
document.documentElement.lang = i18n.language || DEFAULT_LOCALE

function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as ReadonlyArray<string>).includes(value)
}

/** Reconcile the active locale with the authenticated professor's
 * `settings.language` — called by AuthContext on bootstrap and login. The
 * professor's saved preference wins on first sync; subsequent local mutations
 * flow back to the backend through Settings page Save. */
export function syncLanguageFromProfessor(language: unknown) {
  if (!isLocale(language)) return
  if (i18n.language === language) return
  void i18n.changeLanguage(language)
}

export default i18n
